/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FaEnvelope } from '@react-icons/all-files/fa/FaEnvelope';
import { FaQuestionCircle } from '@react-icons/all-files/fa/FaQuestionCircle';

import LinkList from 'gatsby-core-theme/src/components/molecules/link-list';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import Modal from 'gatsby-core-theme/src/hooks/modal';
import { imagePrettyUrl, translate } from 'gatsby-core-theme/src/helpers/getters';
import { Context } from '~context/TranslationsProvider';
import styles from './footer.module.scss';

/* eslint-disable react/no-danger */

const Footer = ({ section, hasAdDiscModal = false }) => {
  const { translations } = useContext(Context) || {};
  const data = section.extra_fields;
  const topIcons = [<FaEnvelope />, <FaQuestionCircle />];
  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        <div className={!data?.footer_top_right && styles.centerList}>
          <div className={styles.mainLinks}>
            <LinkList
              lists={data?.footer_top_left}
              singleList
              multiIcon
              listIcon={topIcons}
              gtmClass="mobile-menu-gtm"
            />
            <LinkList
              lists={data?.footer_top_right}
              singleList
              classes={styles.rightList}
              gtmClass="mobile-menu-gtm"
            />
          </div>
        </div>
        <div className={styles.socialIcons}>
          <LinkList
            lists={data?.footer_top_logos}
            singleList
            imageOnly
            gtmClass="mobile-menu-gtm logo-cta"
          />
        </div>
      </div>
      <div className={styles.footerBottom}>
        <div className={styles.responsiveImage}>
          <LazyImage
            src={imagePrettyUrl(data?.responsive_image, 158, 86)}
            alt={translate(
              translations,
              'footer_responsive_image',
              'On smartphone and other devices'
            )}
            className={styles.screenSizes}
            width={158}
            height={86}
          />
          <p dangerouslySetInnerHTML={{ __html: data?.gambling_text }} />
        </div>
        <div className={styles.footerBottomLinks}>
          <LinkList lists={data?.footer_bottom} singleList gtmClass="mobile-menu-gtm" />
          <div className={styles.footerModals}>
            <Modal content={data?.modal_text}>
              <span className={styles.modalLink}>
                <LazyImage
                  src="../../../../../../images/age-policy.jpg"
                  height={21}
                  width={21}
                  alt={translate(translations, 'age_policy', 'Age policy')}
                />
                {translate(translations, 'age_policy', 'Age policy')}
              </span>
            </Modal>
            {hasAdDiscModal && (
              <Modal content={data?.advertiser_disclosure_modal_text}>
                <span className={styles.modalLink}>
                  {translate(translations, 'advertiser_disclosure', 'Advertiser Disclosure')}
                </span>
              </Modal>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

Footer.propTypes = {
  section: PropTypes.shape({
    extra_fields: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    modules: PropTypes.arrayOf(
      PropTypes.shape({
        short_code: PropTypes.string,
        value: PropTypes.string,
        title: PropTypes.string,
        image: PropTypes.string,
      })
    ),
  }),
  hasAdDiscModal: PropTypes.bool,
};
